// @flow
import { APP_NAMESPACE } from "shared/constants/application";

const namespace: string = `${APP_NAMESPACE}/createCabelasClass`;

export const EVENT_CONTENT_REQUEST = `${namespace}/EVENT_CONTENT/FETCH`;
export const EVENT_CONTENT_REQUEST_SUCCESS = `${namespace}/EVENT_CONTENT/SUCCESS`;
export const EVENT_CONTENT_REQUEST_ERROR = `${namespace}/EVENT_CONTENT/ERROR`;

export const TEMPLATES_REQUEST = `${namespace}/TEMPLATES/FETCH`;
export const TEMPLATES_REQUEST_SUCCESS = `${namespace}/TEMPLATES/SUCCESS`;
export const TEMPLATES_REQUEST_ERROR = `${namespace}/TEMPLATES/ERROR`;

export const POST_CABELAS_CLASSES_REQUEST = `${namespace}/POST_BATCH/REQUEST`;
export const POST_CABELAS_CLASSES_ROW_RESULT = `${namespace}/POST_BATCH/ROW_RESULT`;
export const POST_CABELAS_CLASS_SUCCESS = `${namespace}/POST/SUCCESS`;
export const POST_CABELAS_CLASS_ERROR = `${namespace}/POST/ERROR`;

export const TIMEZONE_LOOKUP = `${namespace}/TIMEZONE_LOOKUP`;
export const TIMEZONE_LOOKUP_REQUEST = `${namespace}/TIMEZONE_LOOKUP/REQUEST`;
export const TIMEZONE_LOOKUP_SUCCESS = `${namespace}/TIMEZONE_LOOKUP/SUCCESS`;
export const TIMEZONE_LOOKUP_ERROR = `${namespace}/TIMEZONE_LOOKUP/ERROR`;
export const TIMEZONE_LOOKUP_CLEAR = `${namespace}/TIMEZONE_LOOKUP/CLEAR`;

export const INSTRUCTOR_LOCATIONS_REQUEST = `${namespace}/INSTRUCTOR_LOCATIONS/REQUEST`;
export const INSTRUCTOR_LOCATIONS_SUCCESS = `${namespace}/INSTRUCTOR_LOCATIONS/SUCCESS`;
export const INSTRUCTOR_LOCATIONS_ERROR = `${namespace}/INSTRUCTOR_LOCATIONS/ERROR`;
